import { atom } from 'recoil';

export const ProductRangeAtom = atom<EmissaryElixirs.ProductRange[]>({
  key: 'product-range',
  default: []
});
